var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 17.25V10.8333C12.4167 10.5902 12.3289 10.3571 12.1726 10.1852C12.0163 10.0132 11.8043 9.91667 11.5833 9.91667H4.91667C4.69565 9.91667 4.48369 10.0132 4.32741 10.1852C4.17113 10.3571 4.08333 10.5902 4.08333 10.8333V17.25M4.08333 0.75V4.41667C4.08333 4.65978 4.17113 4.89294 4.32741 5.06485C4.48369 5.23676 4.69565 5.33333 4.91667 5.33333H10.75M10.9167 0.75C11.3563 0.756888 11.7756 0.954574 12.0833 1.3L15.25 4.78333C15.564 5.12182 15.7437 5.58309 15.75 6.06667V15.4167C15.75 15.9029 15.5744 16.3692 15.2618 16.713C14.9493 17.0568 14.5254 17.25 14.0833 17.25H2.41667C1.97464 17.25 1.55072 17.0568 1.23816 16.713C0.925595 16.3692 0.75 15.9029 0.75 15.4167V2.58333C0.75 2.0971 0.925595 1.63079 1.23816 1.28697C1.55072 0.943154 1.97464 0.75 2.41667 0.75H10.9167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.7248c78ec0c27967610b805902854457.svg";
export { ForwardRef as ReactComponent };